import "../../../Styles/main.scss"

function Card(props: { children: any }) {
    return <div className="card">{props.children}</div>
}

export default Card
